export enum PropertyTypeEnum {
    Departamento = 1,
    Casa =  2,
    Ph = 3,
    Oficina = 4,
    Local = 5
  }